import * as React from "react";
import { Spinner } from "kea-react";
import { componentToRx as CR } from "react-rxk";
/**
 * Convert a react component to a one that accepts rxjs observable on all its props
 */
export function componentToRx<TProps>(component: (React.ComponentClass<TProps> | ((props: TProps) => (JSX.Element | null)))) {
    return CR(component, <Spinner /> );
}


// WEBPACK FOOTER //
// ./app/logic/rx.tsx